var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashFilter2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.623,
    height: 37.5,
    viewBox: "0 0 97.623 37.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12481",
    "data-name": "Group 12481",
    transform: "translate(-749.563 178.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40572",
    "data-name": "Path 40572",
    d: "M665.83,278.5h29c13,0,12-12-7-12.5-10.367-.272-41.118-.2-61-.111,0,0-10.231-14.392-12.616-14.392h-4.248l2.864,17-4.864,8.5h4.248l13.616-7.427",
    transform: "translate(142.891 -429)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40573",
    "data-name": "Path 40573",
    d: "M650.83,278.5h-10c-4.616,0-12.485-1.836-21-6",
    transform: "translate(142.891 -429)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1065",
    "data-name": "Line 1065",
    x1: 7,
    transform: "translate(837.721 -158.503)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40574",
    "data-name": "Path 40574",
    d: "M667.83,265.5s-17-11-19-11h-6.864l6.864,11",
    transform: "translate(142.891 -429)",
    fill: "none",
    stroke: "",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40575",
    "data-name": "Path 40575",
    d: "M670.592,275.5s-19.239,12-22,12h-7.625l12.864-12",
    transform: "translate(142.891 -429)",
    fill: "none",
    stroke: "",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashFilter2);
export default __webpack_public_path__ + "static/media/dash-filter-2.cc2c68618c8058b8a56b3f693d42c328.svg";
export { ForwardRef as ReactComponent };